import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string) {
  return new Date(date).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  })
}

export function formatShortDate(date: string) {
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  })
}

/**
 * Avatar initials — the first word's initial plus the *last* word's, uppercased.
 * Ports RN `initials` (`src/lib/utils.ts:18-23`), which the App Clip also mirrors
 * as `memberInitials` in `targets/clip/Theme/MembersLayout.swift`.
 */
export function initials(name: string): string {
  const [first, ...rest] = name.trim().split(/\s+/)
  return first ? (first[0] + (rest.at(-1)?.[0] ?? "")).toUpperCase() : "?"
}
